import { Card, styled, useMediaQuery } from '@mui/material';
import type { FC } from 'react';
import type { UnresolvedFaultsDto } from '../../models';
import { AvaniFaultsMessage, NoFaultsMessage } from '../DataDisplay';

type AvaniFaultsBannerProps = {
  faults: UnresolvedFaultsDto[];
};

const AvaniStyledFaultsBannerCard = styled(Card)(
  ({ theme }) => `
  border-radius: 16px;
  padding: 16px;
  height: ${useMediaQuery(theme.breakpoints.down('sm')) ? 'auto' : '248px'};
  background: url('/static/images/background/faultsbanner-BGR.svg') no-repeat center center;
  background-size: cover;
`
);

export const AvaniFaultsBannerCard: FC<AvaniFaultsBannerProps> = ({ faults }) => {
  return (
    <AvaniStyledFaultsBannerCard>
      {!!faults.length && <AvaniFaultsMessage faults={faults} />}
      {!faults.length && <NoFaultsMessage />}
    </AvaniStyledFaultsBannerCard>
  );
};
